import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { DataService } from "src/app/shared/services/data/data.service";
import { CacheService } from 'src/app/cache.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  public dataService: DataService;
  readonly notificationApiUrl = environment.notificationApiUrl;
  readonly preferenceURL = `${this.notificationApiUrl}/preferences/general`;
  readonly monitoringURL = `${environment.monitoringApiUrl}/monitoring/preferences`;
  private disableActions = new BehaviorSubject<boolean>(true);
  disableActions$ = this.disableActions.asObservable();

  constructor(dataService: DataService, private http: HttpClient, private cacheService: CacheService) {
    this.dataService = dataService;
  }

  private userSelectedSource = new Subject<{ userId: number, userType: string, email: string }>();
  userSelected$ = this.userSelectedSource.asObservable();

  selectUser(user: { userId: number, userType: string, email: string }) {
    this.userSelectedSource.next(user);
  }

  getPreferences(userId: number, userType: string) {
    const option = {
      url: `${this.preferenceURL}/user-id/${userId}/user-type/${userType}`
    }

    return this.dataService.get(option)
  }

  getDatonAndNotificationRecipients(companyId: number) {
    const option = {
      url: `${this.notificationApiUrl}/recipients/all-recipients/company-id/${companyId}`,
    }

    return this.dataService.get(option)
  }
  
  deleteRecipient(recipientId: number) {
    const option = {
      url: `${this.notificationApiUrl}/recipients?recipientId=${recipientId}`,
    }

    return this.dataService.delete(option)
  }

  submitPreferences({ userId, groupId, channel, selected, userType }) {
    const option = {
      url: `${this.preferenceURL}`,
      param: {
        userId: userId.toString(),
        groupId: groupId.toString(),
        channel,
        selected,
        userType
      }
    }
    return this.dataService.put(option);
  }

  getDataDelayIntegrations(companyId: number) {
    const option = {
      url: `${this.monitoringURL}/${companyId.toString()}`,
    }

    return this.dataService.get(option);
  }

  // submitDataDelay({companyId, data}){
  //   const option = {
  //     url: `${this.monitoringURL}`,
  //     param: {
  //       companyId: companyId.toString(),
  //     },
  //     data
  //   }

  //   return this.dataService.put(option);
  // }

  submitDataDelay({ companyId, enabled, dataList }) {
    const queryParams = new URLSearchParams({
      companyId: companyId?.toString(),
    });

    let dataObjects: { [key: string]: boolean } = {};
    for (let i = 0; i < dataList.length; i++) {
      dataObjects[`${dataList[i]}`] = enabled;
    }

    const url = `${this.monitoringURL}?${queryParams.toString()}`;

    return this.dataService.put({
      url: url,
      data: dataObjects
    });
  }

  saveRecipients(companyId: number, email: string) {
    const option = {
      url: `${this.notificationApiUrl}/recipients`,
      param: {
        companyId: companyId.toString(),
        email: email
      }
    };
    return this.dataService.post(option);
  }
  
  submitDataDelayWithSourceId(companyId: number, sourceId: number) {
    const url = `${this.monitoringURL}/company-id/${companyId}/source-id/${sourceId}`;
    const option = {
      url: url
    };
    return this.dataService.post(option);
  }

  setDisableAction(value: boolean) {
    this.disableActions.next(value);
  }

  oAuth({ companyId, provider }) {
    const option = {
      url: `${this.notificationApiUrl}/${provider}/oauth/${companyId}`,
    }

    return this.dataService.get(option)
  }

  isSlackAuthenticated(companyId) {
    const option = {
      url: `${this.notificationApiUrl}/slack/check/${companyId}`
    }
    return this.dataService.get(option)
  }

  checkMonitorExists(companyId: number) {
    const option = {
      url: `${this.monitoringURL}/monitor-exists/${companyId}`,
    }
    return this.dataService.get(option);
  }

  getAutoSubscribeState(userId) {
    const option = {
      url: `${this.notificationApiUrl}/preferences/auto-subscribed/${userId.toString()}`,
    };
    return this.dataService.get(option);
  }

  setAutoSubscribeState(userId, state, monitoringChannelStatus) {
    const option = {
      url: `${this.notificationApiUrl}/preferences/general?userId=${userId.toString()}`,
      param: {
        groupId: '8',
        channel: 'EMAIL',
        autoSubscribed: state,
        selected: monitoringChannelStatus,
        userType:'DATON'
      }
    };
    return this.dataService.put(option);
  }

}
